<template>
  <div>
    <TheHeader :key="$route.fullPath"></TheHeader>

    <IeMessage v-if="$store.getters.isIE" />

    <main class="content --has-no-padding" v-else>
      <transition name="modal-backdrop-transition" appear>
        <router-view />
      </transition>
    </main>

    <TheFooter></TheFooter>

    <ModalProduct v-if="$store.getters.getModalOpen && !$store.getters.isIE" />

    <TheLoader v-if="$store.getters.getGlobalLoading && !$store.getters.isIE" />

    <ShoppingSetupModal v-if="showSetupModal" />

  </div>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';

import IeMessage from '@/views/Common/IeMessage';
import TheHeader from '@/components/TheHeader';
import TheFooter from '@/components/TheFooter';
import ModalProduct from '@/components/ModalProduct';
import TheLoader from '@/components/TheLoader';
import ShoppingSetupModal from '@/components/Configurator/ShoppingSetupModal';

export default {
  components: {
    IeMessage,
    TheHeader,
    TheFooter,
    ModalProduct,
    TheLoader,
    ShoppingSetupModal,
  },
  mixins: [logicMixin],
  data () {
    return {
      showSetupModal: false
    };
  },
  mounted () {
    this.$root.$on('showSetupModal', () => {
      if (this.$store.getters.isB2b) {
        const show = localStorage.getItem('setupModal');

        if (show === null) {
          this.showSetupModal = true;
          localStorage.setItem('setupModal', true);
        }
      }
    });

    if (!(this.$route.path.startsWith('/b2c') || this.$route.path.startsWith('/b2b'))) {
      const show = localStorage.getItem('typeChooser');
      if (show === null) {
      } else {
        this.$router.push(this.cLink(this.$route.path));
      }
    } else {
      localStorage.setItem('typeChooser', true);
    }

    this.$root.$on('closeSetupModal', () => {
      this.showSetupModal = false;
    });
  }
};
</script>
